import TickIcon from "@/assets/icons/tick.svg?react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ImportantNote } from "@/components/ui/importantNote";
import { Typography } from "@/components/ui/typography";

type JobDetailsFormData = {
  job_number: string;
  plant_name: string;
  service_name: string;
  design_code: string;
  repair_system: string;
  surface_preparation: string;
  branch: string;
};

type ConfirmJobDetailsProps = {
  confirmData: JobDetailsFormData | null;
  setConfirmData: (data: JobDetailsFormData | null) => void;
  repairSystemOptions: { title: string; value: number }[];
  surfacePreparationOptions: { title: string; value: number; long_name: string }[];
  handleSaveJobDetails: () => void;
};
export function ConfirmJobDetails({
  confirmData,
  setConfirmData,
  surfacePreparationOptions,
  repairSystemOptions,
  handleSaveJobDetails,
}: ConfirmJobDetailsProps) {
  return (
    <Dialog open={!!confirmData} onOpenChange={() => setConfirmData(null)}>
      <DialogContent>
        <DialogTitle>Confirm Job Details</DialogTitle>
        <DialogDescription>Review and confirm your job details before saving</DialogDescription>
        <div className="flex w-[300px] flex-col md:w-[400px]">
          <div className="mb-4 flex justify-between">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-success-50">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-success-100">
                <TickIcon className="h-[11px] w-[16px]" />
              </div>
            </div>
          </div>
          <ImportantNote>
            Please confirm that the repair system is compatible with {confirmData?.service_name}. Additionally, please
            confirm the details below are correct
          </ImportantNote>
          {confirmData && (
            <div>
              <div className="mb-4 grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Job Number:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.job_number}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Plant Name:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.plant_name}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Service:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.service_name}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Design Code:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {confirmData.design_code}
                </Typography>
              </div>
              <div className="mb-4 grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Repair System:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {repairSystemOptions.find((r) => confirmData.repair_system == String(r.value))?.title}
                </Typography>
              </div>
              <div className="grid grid-cols-2">
                <Typography variant="text-md" className="text-gray-800" weight="semibold">
                  Surface preparation:
                </Typography>
                <Typography variant="text-md" className="text-gray-600">
                  {surfacePreparationOptions.find((s) => confirmData.surface_preparation == String(s.value))?.title}
                </Typography>
              </div>
            </div>
          )}
          <div className="mt-8 flex gap-2">
            <Button variant="outline" className="flex-1 self-end" onClick={() => setConfirmData(null)}>
              Cancel
            </Button>
            <Button className="flex-1 self-end" onClick={handleSaveJobDetails}>
              Confirm
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
